var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEarnDescriptionDecoration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 706,
    height: 592,
    viewBox: "0 0 706 592",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M162.923 345.071L270.578 345.071L271.539 345.071L433.501 345.071L434.462 345.071L503.077 345.071C525.168 345.071 543.077 327.162 543.077 305.071L543.077 -0.000267879L706 -0.000275001L706 345.071L706 467.782C706 489.874 688.091 507.782 666 507.782L559.369 507.782L543.077 507.782L473.501 507.782C451.41 507.782 433.501 525.691 433.501 547.782L433.501 591L270.578 591L270.578 547.782C270.578 525.691 252.669 507.782 230.578 507.782L202.923 507.782C180.832 507.782 162.923 525.691 162.923 547.782L162.923 591.782L0 591.782L-5.9592e-06 385.071C-6.59606e-06 362.979 17.9086 345.071 40 345.071L162.923 345.071Z",
    fill: "url(#paint0_linear_415_164)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_415_164",
    x1: -0.0000129338,
    y1: 295.891,
    x2: 706,
    y2: 295.891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.512661,
    stopColor: "#04C35C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33CC66",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarnDescriptionDecoration);
export default __webpack_public_path__ + "static/media/EarnDescriptionDecoration.5fd55047f42e651474652fa195f13387.svg";
export { ForwardRef as ReactComponent };